import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { Esri4MapService } from './../../core/index';


export class CustomWidgetDirective implements OnInit {

   position: string;

  private el: HTMLElement;

  constructor(el: ElementRef, private mapService: Esri4MapService) {
    this.el = el.nativeElement;
  }

  ngOnInit() {
    this.mapService.isLoaded.subscribe(() => {
      // after map is loaded then add widget
      this.mapService.addWidget(this.el, this.position);
    });
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[esri4-customWidget]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Esri4MapService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'position': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
